export const BikeModelSalesAudienceOptions = ["Public", "Waitlist", "None"] as const;
export type BikeModelSalesAudience = (typeof BikeModelSalesAudienceOptions)[number];
